angular
  .module('contributor')

  .factory('ConnectionCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class ConnectionCrud extends Crud {
        constructor(list) {
          super(
            'connection' + (list || ''),
            '@@apiUrl' + '/connections' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return ConnectionCrud;
    }
  ]);
